import * as React from 'react'

function IconEdit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={48}
      height={49}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#prefix__clip0)"
        stroke="#E84E25"
        strokeWidth={6}
        strokeLinecap="round"
      >
        <path
          d="M14.486 11.939c-1.573 0-3.13.307-4.583.904a11.983 11.983 0 00-3.885 2.575 11.876 11.876 0 00-2.596 3.855 11.799 11.799 0 00-.911 4.546v10.793a11.834 11.834 0 003.51 8.396 12.023 12.023 0 008.465 3.476h10.878c3.174 0 6.218-1.25 8.462-3.477a11.825 11.825 0 003.505-8.395"
          strokeMiterlimit={10}
        />
        <path
          d="M38.837 19.992l-10.879-9.598-9.205 10.976a16.882 16.882 0 00-4.31 11.764v0a3.555 3.555 0 001.212 2.576 3.614 3.614 0 002.722.886v0a17.095 17.095 0 0011.264-5.62l9.196-10.984zM43.045 4.31a7.333 7.333 0 00-5.272-1.81 7.32 7.32 0 00-5.02 2.415l-.26.399 10.879 9.605.26-.398a7.204 7.204 0 001.835-5.226 7.218 7.218 0 00-2.422-4.986v0zM18.736 21.378l10.896 9.598M33.389 15.193l-9.205 10.984"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h48v49H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconEdit
